import {gql} from "apollo-angular";
import {baseResponse} from "src/app/store/base.graphql";

const collaborationReasonFields = `
id
uniqueId
reason
createdAt
createdBy {
  id
  profileUniqueId
  userFirstName
  userLastName
}
`;

export const CREATE_COLLABORATION_REASON = gql`
mutation CreateCollaborationSettingsMutation($input: CollaborationSettingsInputObject) {
  createCollaborationSettingsMutation(input: $input) {
    response {
      ${baseResponse}
    }
    data {
      ${collaborationReasonFields}
    }
  }
}
`;

export const UPDATE_COLLABORATION_REASON = gql`
mutation UpdateCollaborationSettingsMutation($input: CollaborationSettingsInputObject) {
  updateCollaborationSettingsMutation(input: $input) {
    response {
      ${baseResponse}
    }
    data {
      ${collaborationReasonFields}
    }
  }
}
`;

export const GET_ALL_COLLABORATION_REASONS = gql`
query GetCollaborationSettings {
  getCollaborationSettings {
    response{
        ${baseResponse}
    }
    data{
        ${collaborationReasonFields}
    }
  }
}
`;


export const DELETE_COLLABORATION_REASON = gql`
mutation DeleteCollaborationSettingsMutation($uniqueId: String!) {
  deleteCollaborationSettingsMutation(uniqueId: $uniqueId) {
    response {
      ${baseResponse}
    }
  }
}
`
